import * as React from 'react';
import { PageMetaContext } from '@studio/contexts/page-meta';

const usePageMeta = (description?: string): void => {
  const globalContext = React.useContext(PageMetaContext);
  const defaultDesc = 'width=device-width, initial-scale=1.0';

  React.useEffect(() => {
    if (!globalContext?.forceMobile) {
      document.querySelector("meta[name='viewport']")?.setAttribute('content', '');
      return () => {
        document.querySelector("meta[name='viewport']")?.setAttribute('content', description || defaultDesc);
      };
    }
  }, [defaultDesc, description, globalContext?.forceMobile]);
};

export default usePageMeta;
